import { render, staticRenderFns } from "./CommunityShow.vue?vue&type=template&id=cf206ed8&scoped=true&"
import script from "./CommunityShow.vue?vue&type=script&lang=js&"
export * from "./CommunityShow.vue?vue&type=script&lang=js&"
import style0 from "./CommunityShow.vue?vue&type=style&index=0&id=cf206ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf206ed8",
  null
  
)

export default component.exports